<div class="py-3">
    <div class="description" *ngIf="artifact.description">{{ artifact.description }}</div>
    <div class="primary">
        <div class="table-section">
            <h3 *ngIf="artifact.name">{{ artifact.name }}</h3>
            <div class="px-2">
                <form [formGroup]="interalForm">
                    <div class="row form-group">
                        <ng-container *ngFor="let field of fields">
                            <div class="col-md-6 pt-3" [ngSwitch]="field.type">
                                <app-form-control *ngSwitchCase="'textarea'"
                                    [form]="interalForm"
                                    [title]="field.label"
                                    [placeholder]="field.placeholder || field.label"
                                    [controlName]="field.name"
                                    [type]="'textarea'"></app-form-control>

                                <app-form-control *ngSwitchCase="'date'"
                                    [form]="interalForm"
                                    [title]="field.label"
                                    [placeholder]="field.placeholder || field.label"
                                    [controlName]="field.name"
                                    [type]="'date'"></app-form-control>

                                <app-form-control *ngSwitchDefault
                                    [form]="interalForm"
                                    [title]="field.label"
                                    [placeholder]="field.placeholder || field.label"
                                    [controlName]="field.name"
                                    [type]="'text'"></app-form-control>

                                <small class="text-muted" *ngIf="field.helpText">{{ field.helpText }}</small>
                            </div>
                        </ng-container>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
